import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cp-bulk-payments',
    templateUrl: './bulk-payments.component.html',
    styleUrls: ['./bulk-payments.component.scss'],
    standalone: false
})
export class BulkPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
